export { default as INITIAL_STATE } from './initialState';

import reducer from './reducer';
export default reducer;
